import Vue from 'vue'
import Vuetify from 'vuetify/lib'
import 'material-design-icons-iconfont/dist/material-design-icons.css'
// Your own translation file
import en from '@/lang/en'
import th from '@/lang/th'
Vue.use(Vuetify)

export default new Vuetify({
    icons: {
        iconfont: 'md'
    },
    theme: {
        themes: {
            light: {
                primary: '#D76436',
                secondary: '#b0bec5',
                anchor: '#8c9eff'
            }
        }
    },
    lang: {
        locales: { th, en },
        current: 'th'
    }
})
